import 'autonumeric/dist/autoNumeric';
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
import AnimatedNumber from './components/AnimatedNumber.vue';

import SceneItemTransition from './components/SceneItemTransition.vue';
import BackButton from './components/BackButton.vue';
import RenderTemplate from './components/RenderTemplate.js';
import ProgressBar from './components/ProgressBar.vue';
import ProgressBarItem from './components/ProgressBarItem.vue';
import QuestionPage from "./components/QuestionPage.vue";
import QuestionAnswer from "./components/QuestionAnswer.vue";

import WelcomePage from './views/WelcomePage.vue';
import Scene from "./views/Scene.vue";
import LoadingPage from "./views/LoadingPage.vue";
import ResultsPage from "./views/ResultsPage.vue";
import DisclaimerAndAssumptionsPage from "./views/DisclaimerAndAssumptionsPage.vue";
import HeaderFyF from "./views/HeaderFyF.vue";
import LifetimeFooter from "./components/LifetimeFooter.vue";

import QPageCohabiting from "./views/Questions/Cohabiting.vue";
import QPageLocation from "./views/Questions/Location.vue";
import QPageHomeFurnishing from "./views/Questions/HomeFurnishing.vue";
import QPageFood from "./views/Questions/Food.vue";
import QPageEatingOut from "./views/Questions/EatingOut.vue";
import QPageTransport from "./views/Questions/Transport.vue";
import QPageHolidays from "./views/Questions/Holidays.vue";
import QPageTreats from "./views/Questions/Treats.vue";
import QPagePersonal from "./views/Questions/Personal.vue";


export default {
  WelcomePage,
  Scene,
  LoadingPage,
  ResultsPage,
  DisclaimerAndAssumptionsPage,
  HeaderFyF,
  LifetimeFooter,
  QPageCohabiting,
  QPageLocation,
  QPageHomeFurnishing,
  QPageFood,
  QPageEatingOut,
  QPageTransport,
  QPageHolidays,
  QPageTreats,
  QPagePersonal,
  VueAutonumeric,
  SceneItemTransition,
  BackButton,
  ProgressBar,
  ProgressBarItem,
  QuestionPage,
  QuestionAnswer,
  AnimatedNumber,
  RenderTemplate,
};
